const snack = require("../../../../../components/snack/snack");

const showError = (id = "downloadError") => snack.start({ act: "show", id });

function runSalePdf(filters, def) {
  const dbid = filters.entityId;
  if (!dbid) return showError();

  const showprice = def.id === "sale-invoice-pdf";
  const pdf = showprice ? "pdf-invoice.php" : "pdf-packSlip.php";

  const formData = new FormData();
  formData.append("sale_id", dbid);
  formData.append("type", "print");

  fetch(`./server/php/queries/report/sale/` + pdf, {
    method: "POST",
    body: formData,
    credentials: "same-origin",
  })
    .then((result) => result.json())
    .then((result) => {
      if (result.file_path && result.print === "true") {
        const iframe = document.querySelector("#reportIframe");
        iframe.src = result.file_path;
        setTimeout(() => iframe.contentWindow.print(), 200);
      }
    })
    .catch(() => showError());
}

export function getData(def, filters) {
  const actions = {
    "sale-invoice-pdf": () => runSalePdf(filters, def),
    "sale-pack-slip-pdf": () => runSalePdf(filters, def),
  };

  const action = actions[def.id];
  action ? action() : showError();
}
